/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Delete_TitleInputs */



/**
* | output |
* | --- |
* | "Delete KNP Guide?" |
*
* @param {Knp_Guide_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_delete_title = /** @type {((inputs?: Knp_Guide_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le guide KNP ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP-Leitfaden löschen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vuoi eliminare la guida KNP?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить путеводитель по КНП?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Eliminar la Guía KNP?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除KNP指南？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNPガイドを削除しますか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी गाइड को हटा दें?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir o Guia do Parque Nacional Kruger?")
	return /** @type {LocalizedString} */ ("Delete KNP Guide?")
});